<template>
    <section class="product-roadmap right-container" id="roadmap" data-anchor="roadmap">

        <h2 class="is-large">Product Roadmap</h2>

        <Slider :slides="slides"
                is-large
        >
        </Slider>

    </section>
</template>

<script>
    import Slider from "./Slider"

    export default {
        name: "ProductRoadmap",
        components: {
            Slider
        },
        data() {
            return {
                slides: []
            }
        },
        beforeCreate () {
            this.$axios.get('/roadmap_items.json').then(({data}) => {
                this.slides = data
            })
        }
    }
</script>